"use strict";

Gantt.plugin(function(gantt) {
  /* это для днд
  function _init_dnd(gantt, grid) {

    var DnD = gantt.$services.getService("dnd");

    if(!grid.$config.bind || !gantt.getDatastore(grid.$config.bind)){
      return;
    }

    function locate(e){
      return domHelpers.locateAttribute(e, grid.$config.item_attribute);
    }

    function getStore(){
      return gantt.getDatastore(grid.$config.bind);
    }

    var dnd = new DnD(grid.$grid_data, {updates_per_second: 60});
    if (gantt.defined(grid.$getConfig().dnd_sensitivity))
      dnd._settings.sensitivity = grid.$getConfig().dnd_sensitivity;

    dnd.attachEvent("onBeforeDragStart", gantt.bind(function(obj, e) {
      var el = locate(e);

      if (!el) {
        return false;
      }

      if (gantt.hideQuickInfo) {
        gantt._hideQuickInfo();
      }

      var id = el.getAttribute(grid.$config.item_attribute);
      var datastore = getStore();
      var task = datastore.getItem(id);

      if (gantt.isReadonly(task)) {
        return false;
      }

      dnd.config.initial_open_state = task.$open;

      if (!gantt.callEvent("onRowDragStart", [id, e.target || e.srcElement, e])) {
        gantt.refreshTask(id);

        return false;
      }

      gantt.config.dndMove = true;
      dnd.config.overlay = document.createElement('DIV');
      dnd.config.overlay.className = 'dnd_overlay';
      gantt.$grid.appendChild(dnd.config.overlay);
      //document.querySelectorAll('.gantt_container')[0].classList.add('dnd_move');
      }, gantt)
    );

    dnd.attachEvent("onAfterDragStart", gantt.bind(function(obj, e) {
      var el = locate(e);

      dnd.config.marker.innerHTML = el.outerHTML;
      dnd.config.id = el.getAttribute(grid.$config.item_attribute);
      dnd.config.lastBetweenOverId = null;

      var store = getStore();
      var task = store.getItem(dnd.config.id);

      dnd.config.index = store.getBranchIndex(dnd.config.id);
      dnd.config.parent = task.parent;
      dnd.config.newParent = null;
      dnd.config.newIndex = null;
      task.$open = 0;
      task.$transparent = true;

      //this.render();
      }, gantt)
    );

    dnd.lastTaskOfLevel = function (level) {
      var last_item = null;
      var store = getStore();
      var tasks = store.getItems();
      for (var i = 0, len = tasks.length; i < len; i++) {
        if (tasks[i].$level == level) {
          last_item = tasks[i];
        }
      }
      return last_item ? last_item.id : null;
    };

    dnd.openParent = _.debounce(function(isOpen, over) {
      if (isOpen && !over.$open) {
        over.$open = 1;
        gantt.render();
      }
    }, 500);

    dnd._getGridPos = gantt.bind(function (e) {
      var pos = domHelpers.getNodePosition(grid.$grid_data);
      var store = getStore();
      // row offset
      var x = pos.x;
      var y = e.pos.y - 10;

      var config = grid.$getConfig();
      // prevent moving row out of grid_data container
      if (y < pos.y) y = pos.y;
      var gridHeight = store.countVisible() * config.row_height;
      if (y > pos.y + gridHeight - config.row_height) y = pos.y + gridHeight - config.row_height;

      pos.x = x;
      pos.y = y;
      return pos;
    }, gantt);

    dnd._getTargetY = gantt.bind(function (e) {
      var pos = domHelpers.getNodePosition(grid.$grid_data);

      var y = e.pageY - pos.y + (gantt.getScrollState().y || 0);
      if (y < 0)
        y = 0;
      return y;
    }, gantt);

    dnd._getTaskByY = gantt.bind(function (y, dropIndex) {

      var config = grid.$getConfig(),
        store = getStore();

      y = y || 0;

      var index = Math.floor(y / config.row_height);
      //index = dropIndex < index ? index - 1 : index;

      if (index > store.countVisible() - 1)
        return null;

      return store.getIdByIndex(index);
    }, gantt);

    dnd.attachEvent("onDragMove", gantt.bind(function(obj, e) {
      var dd = dnd.config;
      var config = grid.$getConfig();

      // highlight row when mouseover
      var item = gantt.isTaskExists(dnd.config.id) && gantt.getTask(dnd.config.id);

      if (!item) {
        return false;
      }

      var targetY = dnd._getTargetY(e);
      var el = dnd._getTaskByY(targetY, gantt.getGlobalTaskIndex(item.id));

      function allowedLevel(next, item) {
        return (
          !gantt.isChildOf(over.id, item.id) &&
          (next.$level == item.$level || gantt.config.order_branch_free)
        );
      }

      if (gantt.isTaskExists(el)) {
        var over = gantt.getTask(el);
        var yPosTop = gantt.getGlobalTaskIndex(over.id) * config.row_height + parseInt((config.row_height / 4), 10);
        var yPosBottom = gantt.getGlobalTaskIndex(over.id) * config.row_height + parseInt((config.row_height / 1.5), 10);

        if (over.$level === 0 || over.type === gantt.config.types.button) {
          dnd.config.newParent = null;
          dnd.config.newIndex = null;
          gantt.manualRemoveDND();
          return;
        }

        var index = gantt.getGlobalTaskIndex(over.id);
        var nextId = gantt.getNext(over.id);//adds +1 when hovering over placeholder
        var next = nextId && gantt.getTask(nextId);
        var prevId = gantt.getPrev(over.id);//adds -1 when hovering over placeholder
        var prev = prevId && gantt.getTask(prevId);

        if (yPosBottom > targetY && yPosTop < targetY) {
          if (+dd.id === +over.id) {
            gantt.manualRefreshDND(over.id);
            return;
          }

          if (this.hasChild(over.id)) {
            if (!over.$open) {
            gantt.manualRefreshDND(over.id);
              dnd.openParent(true, over);
            } else {
              dnd.config.newParent = over.id;
              dnd.config.newIndex = gantt.getTaskIndex(gantt.getNext(over.id));
              gantt.manualRefreshDND(gantt.getNext(over.id), (over && over.id));
            }

            return;
          }

          gantt.manualRefreshDND(over.id);

          dnd.config.newParent = over.id;
          dnd.config.newIndex = 0;
        } else if ((yPosTop > targetY || yPosTop === targetY)) {
          dnd.openParent(false);

          dnd.config.newParent = over.parent;

          if (!gantt.getPrevSibling(over.id)) {
            dnd.config.newIndex = 0;
            gantt.manualRefreshDND(over.id, (prev && prev.id));
          } else if (+prev.id === +dnd.config.id) {
            dnd.config.newIndex = +dnd.config.index;
            gantt.manualRefreshDND(over.id, (prev && prev.id));
          } else {
            if (+dnd.config.parent !== +dnd.config.newParent) {
              if (prev.type === gantt.config.types.button) {
                if(next.type === 'project') dnd.config.newIndex = gantt.getTaskIndex(next.id) - 1;
                else dnd.config.newIndex = gantt.getTaskIndex(prev.id);
              } else {
                dnd.config.newIndex = gantt.getTaskIndex(prev.id) + 1;
              }

              gantt.manualRefreshDND(over.id, (prev && prev.id));
            } else if (gantt.getTaskIndex(prev.id) > dnd.config.index) {
              if (prev.type === gantt.config.types.button) {
                dnd.config.newIndex = gantt.getTaskIndex(prev.parent);
              } else {
                dnd.config.newIndex = gantt.getTaskIndex(prev.id);
              }

              gantt.manualRefreshDND(over.id, (prev && prev.id));
            } else {
              if (prev.type === gantt.config.types.button) {
                dnd.config.newIndex = gantt.getTaskIndex(prev.parent) + 1;
              } else {
                dnd.config.newIndex = gantt.getTaskIndex(prev.id) + 1;
              }

              gantt.manualRefreshDND(over.id, (prev && prev.id));
            }
          }
        } else {
          dnd.openParent(false);

          dnd.config.newParent = over.parent;

          if (over.id === +dnd.config.id) {
            dnd.config.newIndex = +dnd.config.index;

            gantt.manualRefreshDND(over.id, (over && over.id));
          } else if (+dnd.config.parent !== +dnd.config.newParent) {
            if (gantt.hasChild(over.id) && over.$open) {
              dnd.config.newParent = over.id;
              dnd.config.newIndex = gantt.getTaskIndex(gantt.getNext(over.id));

              gantt.manualRefreshDND(next, (over && over.id));
              return;
            }

            dnd.config.newIndex = gantt.getTaskIndex(over.id) + 1;
            gantt.manualRefreshDND(over.id, (over && over.id));

          } else if (dnd.config.index < gantt.getTaskIndex(over.id)) {
            dnd.config.newIndex = gantt.getTaskIndex(over.id);
            gantt.manualRefreshDND(over.id, (over && over.id));
          } else {
            if (gantt.hasChild(over.id) && over.$open) {
              dnd.config.newParent = over.id;
              dnd.config.newIndex = gantt.getTaskIndex(gantt.getNext(over.id));
              gantt.manualRefreshDND(next, (over && over.id));
              return;
            }

            dnd.config.newIndex = gantt.getTaskIndex(over.id) + 1;
            gantt.manualRefreshDND(over.id, (over && over.id));
          }
        }
      }

      return true;
      }, gantt)
    );

    dnd.attachEvent("onDragEnd", gantt.bind(function() {
      gantt.manualRemoveDND();

      var store = getStore();
      var task = store.getItem(dnd.config.id);

      if (dnd.config.overlay && dnd.config.overlay.parentNode) {
        gantt.$grid.removeChild(dnd.config.overlay);
      }

      if (!task) {
        return false;
      }

      task.$transparent = false;
      task.$open = dnd.config.initial_open_state;

      if (dnd.config.newIndex == dnd.config.index && dnd.config.newParent == dnd.config.parent) {
        task.$drop_target = null;
        gantt.config.dndMove = false;
      } else {
        if (
          (!_.isUndefined(dnd.config.newIndex) && !_.isUndefined(dnd.config.newParent)) &&
          (!_.isNull(dnd.config.newIndex) && !_.isNull(dnd.config.newParent)) &&
          gantt.callEvent("onBeforeMoveTask", [dnd.config.id, dnd.config.newParent])
        ) {
          this.moveTask(dnd.config.id, dnd.config.newIndex, dnd.config.newParent);
        }

        if (
          gantt.callEvent("onBeforeRowDragEnd", [
            dnd.config.id,
            dnd.config.parent,
            dnd.config.index
          ]) === false
        ) {
          task.$drop_target = null;
        } else {
          gantt.callEvent("onRowDragEnd", [dnd.config.id, dnd.config.parent]);
        }
      }

      gantt.config.dndMove = false;
      document.querySelectorAll('.gantt_container')[0].classList.remove('dnd_move');
      gantt.refreshData();
      }, gantt)
    );

    gantt.attachEvent("onGanttScroll", gantt.bind(function() {
      if (gantt.config.dndMove && dnd.config) {
        dnd.config.newParent = null;
        dnd.config.newIndex = null;
        gantt.manualRemoveDND();
      }

      }, gantt)
    );
  }

  ////////////////////////////////////////////////////////////////////
  replace property dnd.config => dnd._settings in code below

  if (gantt.defined(config.dnd_sensitivity))
      dnd.config.sensitivity = config.dnd_sensitivity;


  ////////////////////////////////////////////////////////////////////



  ////////////////////////////////////////////////////////////////////

  in ext/drag_timeline/eventsManager in this._startDrag:

  //_this._originalReadonly = gantt.config.readonly;
  //gantt.config.readonly = true;


  ////////////////////////////////////////////////////////////////////
  */

  /*
  ////////////////////////////////////////////////////////////////////

  gantt.locate = function(e) {
		var trg = domHelpers.getTargetNode(e);

		//ignore empty cells
		// var className = domHelpers.getClassName(trg);
		// if ((className || "").indexOf("gantt_task_cell") >= 0) return null;

		var targetAttribute = arguments[1] || this.config.task_attribute;

		var node = domHelpers.locateAttribute(trg, targetAttribute);
		if(node){
			return node.getAttribute(targetAttribute);
		}else{
			return null;
		}
	};

  function makeEventable(obj){

	var eventHost = new EventHost();
	obj.attachEvent=function(name, catcher, callObj){
		name='ev_'+name.toLowerCase();
		if (!eventHost[name])
			eventHost[name] = createEventStorage(callObj||this);

		return(name+':'+eventHost[name].addEvent(catcher)); //return ID (event name & event ID)
	};
	obj.attachAll = function(callback, callObj){
		this.attachEvent('listen_all', callback, callObj);
	};

	obj.callEvent=function(name, arg0, callObj){
		if (eventHost._silent_mode) return true;

		var handlerName = 'ev_'+name.toLowerCase();

		if (eventHost['ev_listen_all']){
			eventHost['ev_listen_all'].apply(callObj || this, [name].concat(arg0));
		}

		if (eventHost[handlerName])
			return eventHost[handlerName].apply(callObj || this, arg0);
		return true;
	};
	obj.checkEvent=function(name){
		return (!!eventHost['ev_'+name.toLowerCase()]);
	};
	obj.detachEvent=function(id){
		if (id){
			var list = id.split(':');           //get EventName and ID
			eventHost[list[0]].removeEvent(list[1]); //remove event
		}
	};
	obj.detachAllEvents = function(){
		for (var name in eventHost){
			if (name.indexOf("ev_") === 0)
				delete eventHost[name];
		}
	};

	obj.blockEvents = function() {
		eventHost._silent_mode = true;
	};

	obj.unblockEvents = function() {
		eventHost._silent_mode = false;
	};

}

 function getCellStyles(targetNode) {
          // creating temp DOM structure for resolving style parameters. Will be removed after calculating.
          var cell = document.createElement("div");
          cell.className = "gantt_task_cell";
          var row = document.createElement("div");
          row.className = "gantt_task_row";
          row.appendChild(cell);
          targetNode.appendChild(row);

          var rowStyles = getComputedStyle(row),
            cellStyles = getComputedStyle(cell);

          var params = {
            bottomBorderWidth: rowStyles.getPropertyValue("border-bottom-width").replace("px", ""),
            rightBorderWidth: cellStyles.getPropertyValue("border-right-width").replace("px", ""),
            bottomBorderColor: rowStyles.getPropertyValue("border-bottom-color"),
            rightBorderColor: cellStyles.getPropertyValue("border-right-color")
          };

          targetNode.removeChild(row);

          if (params.rightBorderWidth === "0") {
            params.rightBorderWidth = "1";
            params.rightBorderColor  = "rgb(235, 235, 235)";
          }

          return params;
 }
/////////////////////////////////////////////





  */


  // remove extensions

//   /***/ "./sources/ext/extensions_all.ts":
//   /*!***************************************!*\
// !*** ./sources/ext/extensions_all.ts ***!
// \***************************************/
//   /*! no static exports found */
//   /***/ (function(module, exports, __webpack_require__) {
//
//     "use strict";
//
//     Object.defineProperty(exports, "__esModule", { value: true });
//     //var auto_scheduling = __webpack_require__(/*! ./auto_scheduling */ "./sources/ext/auto_scheduling.js");
//     var click_drag_1 = __webpack_require__(/*! ./click_drag */ "./sources/ext/click_drag/index.ts");
//     //var critical_path = __webpack_require__(/*! ./critical_path */ "./sources/ext/critical_path.js");
//     var drag_timeline_1 = __webpack_require__(/*! ./drag_timeline */ "./sources/ext/drag_timeline/index.ts");
//     var fullscreen_1 = __webpack_require__(/*! ./fullscreen */ "./sources/ext/fullscreen/index.ts");
//     var grouping = __webpack_require__(/*! ./grouping */ "./sources/ext/grouping.js");
//     //var keyboard_navigation = __webpack_require__(/*! ./keyboard_navigation */ "./sources/ext/keyboard_navigation.js");
//     var marker = __webpack_require__(/*! ./marker */ "./sources/ext/marker.js");
//     var multiselect = __webpack_require__(/*! ./multiselect */ "./sources/ext/multiselect.js");
//     var overlay = __webpack_require__(/*! ./overlay */ "./sources/ext/overlay.js");
//     var quick_info_1 = __webpack_require__(/*! ./quick_info */ "./sources/ext/quick_info/index.ts");
//     var tooltip_1 = __webpack_require__(/*! ./tooltip */ "./sources/ext/tooltip/index.ts");
//     var undo_1 = __webpack_require__(/*! ./undo */ "./sources/ext/undo/index.ts");
//     exports.default = {
//       //auto_scheduling: auto_scheduling,
//       click_drag: click_drag_1.default,
//       //critical_path: critical_path,
//       drag_timeline: drag_timeline_1.default,
//       fullscreen: fullscreen_1.default,
//       //keyboard_navigation: keyboard_navigation,
//       quick_info: quick_info_1.default,
//       tooltip: tooltip_1.default,
//       undo: undo_1.default,
//       grouping: grouping,
//       marker: marker,
//       multiselect: multiselect,
//       overlay: overlay
//     };
//
//
//     /***/ }),

  /*
  //////////////////////////////////////////////////////////////////////

   "./sources/core/ui/render/task_bar_render.js"

   maxWidth = Math.max(maxWidth - 2, 0);//2px for borders => maxWidth = Math.max(maxWidth, 0);

  //////////////////////////////////////////////////////////////////////
*/

//
//
//
//
//
//

//  CRITICAL PATH

  // gantt._isProjectEnd = function(task) {
  //   return !(task.end_date.valueOf() < this._getProjectEnd().valueOf());
  //   /*!(this._hasDuration({
  //     start_date: task.end_date,
  //     end_date: this._getProjectEnd(),
  //     task: task
  //   }));*/
  // };

  // gantt.attachEvent("onLinkIdChange", resetCache);
  // gantt.attachEvent("onAfterLinkUpdate", resetCache);
  // gantt.attachEvent("onAfterLinkDelete", resetCache);
  // gantt.attachEvent("onTaskIdChange", resetCache);
  // gantt.attachEvent("onAfterTaskUpdate", resetCache);
  // gantt.attachEvent("onAfterTaskDelete", resetCache);
  // gantt.attachEvent("onParse", resetCache);
  // gantt.attachEvent("onClearAll", resetCache);
  //
  //
  // var criticalPathHandler = function(){
  //   if(gantt.config.highlight_critical_path)
  //     gantt.render();
  // };
  // gantt.attachEvent("onLinkIdChange", criticalPathHandler);
  // gantt.attachEvent("onAfterLinkUpdate", criticalPathHandler);
  // gantt.attachEvent("onAfterLinkDelete", criticalPathHandler);
  // gantt.attachEvent("onTaskIdChange", criticalPathHandler);
  // gantt.attachEvent("onAfterTaskUpdate", criticalPathHandler);
  // gantt.attachEvent("onAfterTaskDelete", criticalPathHandler);
  //
  // gantt.attachEvent("recalculateCriticalPath", function () {
  //   const topTask = gantt.serialize().data.find(t => !t.parent) || {end_date: gantt.config.end_date};
  //   gantt.config.project_start = null;
  //   gantt.config.project_end = new Date(topTask.end_date);
  //
  //   resetCache();
  //   criticalPathHandler();
  // });


  // Insert in autoscheduling and critical path
  /*!************************************************!*\
    !*** ./sources/core/relations/links_common.js ***!
    \************************************************/
  /*! no static exports found */
  // (function(module, exports) {
  //
  //   module.exports = function (gantt) {
  //     // helpers for building chain of dependencies, used for critical path calculation and for auto scheduling
  //
  //     gantt._get_linked_task = function (link, getTarget) {
  //       var task = null;
  //       var taskId = getTarget ? link.target : link.source;
  //
  //       if (gantt.isTaskExists(taskId)) {
  //         task = gantt.getTask(taskId);
  //       }
  //
  //       return task;
  //     };
  //     gantt._get_link_target = function (link) {
  //       return gantt._get_linked_task(link, true);
  //     };
  //
  //     gantt._get_link_source = function (link) {
  //       return gantt._get_linked_task(link, false);
  //     };
  //
  //     var caching = false;
  //     var formattedLinksStash = {};
  //     var inheritedSuccessorsStash = {};
  //     var inheritedPredecessorsStash = {};
  //     var getPredecessorsCache = {};
  //
  //
  //     gantt._isLinksCacheEnabled = function () {
  //       return caching;
  //     };
  //     gantt._startLinksCache = function () {
  //       formattedLinksStash = {};
  //       inheritedSuccessorsStash = {};
  //       inheritedPredecessorsStash = {};
  //       getPredecessorsCache = {};
  //       caching = true;
  //     };
  //     gantt._endLinksCache = function () {
  //       formattedLinksStash = {};
  //       inheritedSuccessorsStash = {};
  //       inheritedPredecessorsStash = {};
  //       getPredecessorsCache = {};
  //       caching = false;
  //     };
  //
  //     gantt._formatLink = function (link) {
  //       if (caching && formattedLinksStash[link.id]) {
  //         return formattedLinksStash[link.id];
  //       }
  //
  //       var relations = [];
  //       var target = this._get_link_target(link);
  //       var source = this._get_link_source(link);
  //
  //       if (!(source && target)) {
  //         return relations;
  //       }
  //
  //       if ((gantt.isSummaryTask(target) && gantt.isChildOf(source.id, target.id)) || (gantt.isSummaryTask(source) && gantt.isChildOf(target.id, source.id))) {
  //         return relations;
  //       }
  //
  //
  //       // there are three kinds of connections at this point
  //       // task -> task - regular link
  //       // task -> project - transform it into set of regular links (task -> [each subtask]), use offset beetween subtask and project dates as lag, in order not to change mutual positions of subtasks inside a project
  //       // project -> task - transform it into ([each subtask] -> task) links
  //       // project -> project - transform it into ([each subtask of p1] -> [each subtask of p2]) links
  //
  //       var from = this._getImplicitLinks(link, source, function (c) {
  //         return 0;
  //       }, true);
  //
  //       var respectTargetOffset = gantt.config.auto_scheduling_move_projects;
  //       var targetDates = this.isSummaryTask(target) ? this.getSubtaskDates(target.id) : {
  //         start_date: target.start_date,
  //         end_date: target.end_date
  //       };
  //       var to = this._getImplicitLinks(link, target, function (c) {
  //         if (!respectTargetOffset) {
  //           return 0;
  //         } else {
  //
  //           if (!c.$target.length && targetDates.start_date) {// drag_id - virtual lag shouldn't restrict task that is being moved inside project
  //             let dragDuration = gantt.calculateDuration({
  //               start_date: targetDates.start_date,
  //               end_date: c.start_date,
  //               task: source
  //             });
  //
  //             return dragDuration;
  //           } else {
  //             return 0;
  //           }
  //         }
  //       });
  //
  //       for (var i = 0, fromLength = from.length; i < fromLength; i++) {
  //         var fromTask = from[i];
  //         for (var j = 0, toLength = to.length; j < toLength; j++) {
  //           var toTask = to[j];
  //
  //           var lag = fromTask.lag * 1 + toTask.lag * 1;
  //
  //           var subtaskLink = {
  //             id: link.id,
  //             type: link.type,
  //             source: fromTask.task,
  //             target: toTask.task,
  //             lag: (link.lag * 1 || 0) + lag
  //           };
  //
  //           relations.push(gantt._convertToFinishToStartLink(toTask.task, subtaskLink, source, target, fromTask.taskParent, toTask.taskParent));
  //         }
  //       }
  //
  //       if (caching)
  //         formattedLinksStash[link.id] = relations;
  //
  //       return relations;
  //     };
  //
  //     gantt._isAutoSchedulable = function (task) {
  //       return task.auto_scheduling !== false;
  //     };
  //
  //     gantt._getImplicitLinks = function (link, parent, selectOffset, selectSourceLinks) {
  //       var relations = [];
  //
  //       if (this.isSummaryTask(parent)) {
  //
  //         // if the summary task contains multiple chains of linked tasks - no need to consider every task of the chain,
  //         // it will be enough to check the first/last tasks of the chain
  //         // special conditions if there are unscheduled tasks in the chain, or negative lag values that put the end date of the successor task prior to its predecessors' date
  //         var children = {};
  //         this.eachTask(function (c) {
  //           if (!this.isSummaryTask(c) && gantt._isAutoSchedulable(c)) {
  //             children[c.id] = c;
  //           }
  //         }, parent.id);
  //
  //         var skipChild;
  //
  //         for (var c in children) {
  //           var task = children[c];
  //           var linksCollection = selectSourceLinks ? task.$source : task.$target;
  //
  //           skipChild = false;
  //
  //           for (var l = 0; l < linksCollection.length; l++) {
  //             var siblingLink = gantt.getLink(linksCollection[l]);
  //             var siblingId = selectSourceLinks ? siblingLink.target : siblingLink.source;
  //             var siblingTask = children[siblingId];
  //             if (siblingTask && task.auto_scheduling !== false && siblingTask.auto_scheduling !== false) {
  //               if ((siblingLink.target == siblingTask.id && Math.abs(siblingLink.lag) <= siblingTask.duration) ||
  //                 (siblingLink.target == task.id && Math.abs(siblingLink.lag) <= task.duration)) {
  //                 skipChild = true;
  //                 break;
  //               }
  //             }
  //           }
  //           if (!skipChild) {
  //             relations.push({ task: task.id, taskParent: task.parent, lag: selectOffset(task) });
  //           }
  //         }
  //
  //       } else {
  //         relations.push({ task: parent.id, taskParent: parent.parent, lag: 0 });
  //       }
  //
  //       return relations;
  //     };
  //
  //     gantt._getDirectDependencies = function (task, selectSuccessors) {
  //
  //       var links = [],
  //         successors = [];
  //
  //       var linksIds = selectSuccessors ? task.$source : task.$target;
  //
  //       for (var i = 0; i < linksIds.length; i++) {
  //         var link = this.getLink(linksIds[i]);
  //         if (link && this.isTaskExists(link.source) && this.isTaskExists(link.target)) {
  //           var target = this.getTask(link.target);
  //           if (this._isAutoSchedulable(target)) {
  //             links.push(this.getLink(linksIds[i]));
  //           }
  //         }
  //       }
  //
  //       for (var i = 0; i < links.length; i++) {
  //         successors = successors.concat(this._formatLink(links[i]));
  //       }
  //
  //       return successors;
  //     };
  //
  //     gantt._getInheritedDependencies = function (task, selectSuccessors) {
  //
  //       //var successors = [];
  //       var stop = false;
  //       var inheritedRelations = [];
  //       var cacheCollection;
  //       if (this.isTaskExists(task.id)) {
  //         this.eachParent(function (parent) {
  //           if (stop)
  //             return;
  //
  //           if (caching) {
  //             cacheCollection = selectSuccessors ? inheritedSuccessorsStash : inheritedPredecessorsStash;
  //             if (cacheCollection[parent.id]) {
  //               inheritedRelations = inheritedRelations.concat(cacheCollection[parent.id]);
  //               return;
  //             }
  //           }
  //
  //           var parentDependencies;
  //           if (this.isSummaryTask(parent)) {
  //             if (!this._isAutoSchedulable(parent)) {
  //               stop = true;
  //             } else {
  //               parentDependencies = this._getDirectDependencies(parent, selectSuccessors);
  //               if (caching) {
  //                 cacheCollection[parent.id] = parentDependencies;
  //               }
  //
  //               inheritedRelations = inheritedRelations.concat(parentDependencies);
  //             }
  //           }
  //
  //         }, task.id, this);
  //       }
  //
  //       return inheritedRelations;
  //     };
  //
  //
  //     gantt._getDirectSuccessors = function (task) {
  //       return this._getDirectDependencies(task, true);
  //     };
  //
  //     gantt._getInheritedSuccessors = function (task) {
  //       return this._getInheritedDependencies(task, true);
  //     };
  //
  //     gantt._getDirectPredecessors = function (task) {
  //       return this._getDirectDependencies(task, false);
  //     };
  //
  //     gantt._getInheritedPredecessors = function (task) {
  //       return this._getInheritedDependencies(task, false);
  //     };
  //
  //     gantt._getSuccessors = function (task, skipInherited) {
  //       var successors = this._getDirectSuccessors(task);
  //       if (skipInherited) {
  //         return successors;
  //       } else {
  //         return successors.concat(this._getInheritedSuccessors(task));
  //       }
  //     };
  //
  //     gantt._getPredecessors = function (task, skipInherited) {
  //       var key = task.id + skipInherited;
  //       var result;
  //
  //       if (caching && getPredecessorsCache[key]) {
  //         return getPredecessorsCache[key];
  //       }
  //
  //       var predecessors = this._getDirectPredecessors(task);
  //       if (skipInherited) {
  //         result = predecessors;
  //       } else {
  //         result = predecessors.concat(this._getInheritedPredecessors(task));
  //       }
  //       if (caching) {
  //         getPredecessorsCache[key] = result;
  //       }
  //       return result;
  //     };
  //
  //
  // gantt._convertToFinishToStartLink = function (id, link, sourceTask, targetTask, sourceParent, targetParent) {
  //   // convert finish-to-finish, start-to-finish and start-to-start to finish-to-start link and provide some additional properties
  //   var res = {
  //     target: id,
  //     link: gantt.config.links.finish_to_start,
  //     id: link.id,
  //     lag: link.lag || 0,
  //     source: link.source,
  //     preferredStart: null,
  //     sourceParent: sourceParent,
  //     targetParent: targetParent,
  //     hashSum: null
  //   };
  //
  //   var additionalLag = 0;
  //   switch (link.type) {
  //     case gantt.config.links.start_to_start:
  //       // additionalLag = -sourceTask.duration - (gantt.calculateDuration({start_date: sourceTask.end_date, end_date: targetTask.start_date, task: targetTask}));
  //
  //       if (targetTask.id === id ) {
  //         additionalLag = -sourceTask.duration;
  //       } else {
  //         additionalLag = -sourceTask.duration - (gantt.calculateDuration({start_date: sourceTask.end_date, end_date: targetTask.start_date, task: targetTask}));
  //       }
  //       break;
  //     case gantt.config.links.finish_to_finish:
  //       if (gantt.isSummaryTask(targetTask)) {
  //         additionalLag = -gantt.getTask(id).duration;
  //       } else {
  //         additionalLag = -targetTask.duration;
  //       }
  //
  //       break;
  //     case gantt.config.links.start_to_finish:
  //       if (gantt.isSummaryTask(targetTask)) {
  //         additionalLag = -sourceTask.duration - gantt.getTask(id).duration;
  //       } else {
  //         additionalLag = -sourceTask.duration - targetTask.duration;
  //       }
  //
  //       break;
  //     default:
  //       additionalLag = 0;
  //   }
  //
  //   res.lag += additionalLag;
  //   res.additionalLag = additionalLag;
  //   res.hashSum = res.lag + "_" + res.link + "_" + res.source + "_" + res.target;
  //   return res;
  // };

  // };
  //
  //    }),
});
